import { EstadisticasCRM } from "../../bussines/entities/EstadisticasCRM.entity";

export class EstadisticasCRMModel implements EstadisticasCRM {
    constructor(
        public clientesActivos: number,
        public numeroLlamadas: number,
        public numeroSoportes: number,
        public productosVendidos: number
    ) { }

    serialize(): EstadisticasCRM {
        return {
            clientesActivos: this.clientesActivos,
            numeroLlamadas: this.numeroLlamadas,
            numeroSoportes: this.numeroSoportes,
            productosVendidos: this.productosVendidos
        }
    }

    static deserialize(entity: EstadisticasCRM): EstadisticasCRMModel {
        return new EstadisticasCRMModel(
            entity.clientesActivos ?? 0,
            entity.numeroLlamadas ?? 0,
            entity.numeroSoportes ?? 0,
            entity.productosVendidos ?? 0
        );
    }
}